import React from "react";
import { motion } from "framer-motion";
import { Users, Heart, Eye } from "lucide-react";
import givers from "../../../images/givers.png";
import recievers from "../../../images/recievers.png";
import observers from "../../../images/observers.png";
import FadeIn from "../../ui/FadeIn";
import AnimatedCounter from "../../ui/AnimatedCounter";

const stats = [
  {
    label: "Givers",
    sublabel: "Dedicated volunteers",
    value: 220000,
    icon: Users,
    image: givers,
    color: "from-ku-purple to-ku-violet",
    borderColor: "border-ku-purple",
  },
  {
    label: "Receivers",
    sublabel: "Lives directly touched",
    value: 5600000,
    icon: Heart,
    image: recievers,
    color: "from-ku-gold-dark to-ku-gold",
    borderColor: "border-ku-gold",
  },
  {
    label: "Observers",
    sublabel: "Witnessing kindness",
    value: 8200000,
    icon: Eye,
    image: observers,
    color: "from-ku-purple-deep to-ku-purple",
    borderColor: "border-ku-purple-deep",
  },
];

const NumberCounter = () => (
  <section className="relative py-12 md:py-16 bg-white border-y border-ku-soft/60 overflow-hidden">
    <div className="absolute inset-0 bg-noise opacity-10 pointer-events-none" aria-hidden />
    <div className="ku-container relative">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-6">
        {stats.map((stat, i) => (
          <FadeIn key={stat.label} delay={i * 0.08}>
            <motion.div
              whileHover={{ y: -4, scale: 1.02 }}
              transition={{ type: "spring", stiffness: 300 }}
              className={`text-center p-5 rounded-2xl bg-ku-cream/60 hover:bg-white hover:shadow-card transition-all duration-300 border-t-3 ${stat.borderColor} cursor-default`}
              style={{ borderTopWidth: "3px" }}
            >
              <div className={`inline-flex p-2.5 rounded-xl bg-gradient-to-br ${stat.color} mb-3 shadow-sm`}>
                <stat.icon className="w-5 h-5 text-white" />
              </div>
              {stat.image && (
                <img src={stat.image} alt="" className="h-10 mx-auto mb-2 object-contain" />
              )}
              <p className="font-display text-2xl md:text-3xl font-bold text-ku-purple">
                <AnimatedCounter value={stat.value} />
                {stat.suffix && <span>{stat.suffix}</span>}
              </p>
              <p className="font-accent text-[10px] font-bold text-ku-violet uppercase tracking-widest mt-1">{stat.label}</p>
              <p className="font-body text-gray-500 text-xs mt-0.5">{stat.sublabel}</p>
            </motion.div>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);

export default NumberCounter;
